exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._58d0c4{filter:grayscale(100%)}._019bee{left:-100000em;position:absolute}", ""]);
// Exports
exports.locals = {
	"grayscale": "_58d0c4",
	"hide": "_019bee"
};